<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M15.313 12.462L8.671 6h14.657l-6.642 6.462c-.27.288-.226.654-.226 1.085l-.068 11.803-.692.674v-12.69c0-.196-.033-.41-.125-.571a2.228 2.228 0 00-.262-.3zm-.165 16.758a1.046 1.046 0 01-.476.113c-.568 0-1.028-.447-1.028-1V13.667l-8.01-7.793a.98.98 0 010-1.414c.089-.087.19-.154.297-.202A1.04 1.04 0 016.621 4h18.843c.325 0 .614.146.803.375a.98.98 0 01.099 1.499l-7.85 7.636-.07 12.168a.975.975 0 01-.1.424.991.991 0 01-.26.43l-2.506 2.437a1.03 1.03 0 01-.432.251z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsFunnelOutline'
}
</script>
